module.exports = __webpack_public_path__ + "static/media/dollar-symbol.a98f49ac.svg";